import styled from 'styled-components';
import Spacer from 'components/Spacer';

export const Root = styled(Spacer)`
  width: 100%;
  max-height: 200px;
  display: block;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  object-fit: cover;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;
